/*
 * Copyright (c) 2022.
 * ISNLab
 * Owner and rewriter: Sedov A. Sergey
 * sedov.sergey@isnlab.com
 */

import {computed, reactive} from "vue";
import axios from "axios";
import { router } from "@/router";
import { useRoute } from 'vue-router';
import {Request, RequestLocal} from "./client";

//-----------------------------------------------------------------------------
// State
//-----------------------------------------------------------------------------

const state = reactive({
    has_error: false,
    is_loading: false,
    is_global_loading: true,
    status: 1,
    loading_message: 'Loading...',
    error_message: '',
    token: localStorage.getItem('token') || '',
    user : null,
    stream: JSON.parse(localStorage.getItem('stream') || null),

});

//-----------------------------------------------------------------------------
// Mutations
//-----------------------------------------------------------------------------

function setApiKey()
{
    axios.defaults.headers.common['X-Api-Key'] = state.token || ''
    axios.defaults.headers.common['X-Stream-ID'] = state.stream && state.stream.user_id || ''
}

function checkStatus()
{
    if (state.user) {
        if (state.user.user_status === 0) { //not approoved
            console.log('na')
            notApproved()
        }
        if (state.user.user_status === 2) { //blockerd
            console.log('di')
            blocked()
        }
    }
}

function authSuccess(userdata)
{
    state.token = userdata.token || ''
    state.user = userdata.user || null
    state.status = 1;
    localStorage.setItem('token', userdata.token)
    setStream(userdata.stream,true)
    setApiKey()
    checkStatus()
    router.push('/member/index')
}

function authDrop()
{
    state.token = ''
    state.user = null
    state.stream = null
    state.status = 1

    localStorage.removeItem('token')
    localStorage.removeItem('stream')
    delete axios.defaults.headers.common['X-Api-Key']
    delete axios.defaults.headers.common['X-Stream-ID']
}

function setStream(stream, redirect)
{
    // console.log(stream)
    state.stream = stream || null
    localStorage.setItem('stream', JSON.stringify(state.stream))
    setApiKey()
    if (!redirect)
    {
        return
    }
    if (stream)
    {
        router.push({name:'Index'})
    }
    else
    {
        router.push({name:'Streams'})
    }

}

function gotError(err)
{
    state.error_message = err.response.statusText
    if (err.response.data)
    {
        if (err.response.data.message) {
            state.error_message = err.response.data.message.replace(/\n/g, "<br />");
        }
        else
        {
            state.error_message = err.response.data.replace(/\n/g, "<br />");
        }
    }

    state.is_loading = false;
    state.has_error = true
}

function currentUser()
{
    return state.user;
}

function showError(err)
{
    state.error_message = err
    state.is_loading = false;
    state.has_error = true
}

function doGlobalLoading()
{
    state.is_global_loading = true;
}

function doLoading(message)
{
    state.is_loading = true;
    state.has_error = false;
    state.loading_message = (message) ? message : 'Loading'
}

function clearError()
{
    state.has_error = false;
    state.loading_message = ''
}

function loadingGlobalDone()
{
    state.is_global_loading = false;
}

function loadingDone()
{
    state.is_loading = false;
}

//-----------------------------------------------------------------------------
// Actions
//-----------------------------------------------------------------------------

function loadProfile(full)
{
    if (isLoggedIn.value === false)
    {
        logout();
    }
    if (isLoggedIn.value === true && state.user === null)
    {
        setApiKey();
        Request('profile', {params: {f: full === true ? 1 : 0}, method: 'GET'})
            .then(function (response) {
                state.user = response.data.profile;
                if (response.data.stream) {
                    setStream(response.data.stream, false);
                }
                checkStatus()
                loadingGlobalDone()
            })
    }
    else
    {
        loadingGlobalDone()
    }

}

function allLoadingDone() {
    loadingDone()
    loadingGlobalDone()
}

function unAuth(toLoginPage)
{
    authDrop()
    if (toLoginPage === true) {
        router.push({name: 'Login'});
    }
    allLoadingDone()
}

function to404(){
    router.push({name: 'NotFound'});
}

function notApproved(){
    state.status = 0;
    router.push({name: 'NotApproved'});
    allLoadingDone()
}
function blocked(){
    state.status = 2;
    router.push({name: 'Blocked'});
    allLoadingDone()
}

function logout(toLoginPage)
{
    if (isLoggedIn.value) {
        RequestLocal('logout', {method: 'GET'})//.catch(err => {})
    }
    unAuth(toLoginPage)
}

//-----------------------------------------------------------------------------
// Getters
//-----------------------------------------------------------------------------

const isError = computed(() => !!state.has_error)
const isNotApproved = computed(() => state.status === 0)
const isBlocked = computed(() => state.status === 2)
const isLoading = computed( () => !!state.is_loading)
const isGlobalLoading = computed( () => !!state.is_global_loading)
const isLoggedIn = computed(() => state.token !== '')
const isStreamSelected = computed(() => !!state.stream)
const currentStream = computed(() => state.stream)
const errorMessage = computed(() => state.error_message)
const messagesCount = computed(() => state.user ? state.user.Messages.count : 0)
const affiliateLink = computed(() => state.stream && state.stream.aff_link ? state.stream.aff_link : '')
const telegramHash = computed(() => state.user && state.user.tlgHash ? state.user.tlgHash : null)
// const telegramHashLink = computed(() => state.user && state.user.tlgHash ? 'https://t.me/RomanceNetBot?start=' + state.user.tlgHash : 'https://t.me/RomanceNetBot')
const currentRoute = computed(() => useRoute().name)

function getState()
{
    return state
}




export {
    isError,
    isLoggedIn,
    isLoading,
    isGlobalLoading,
    errorMessage,
    isNotApproved,
    isBlocked,
    isStreamSelected,
    currentStream,
    loadingGlobalDone,
    loadingDone,
    doGlobalLoading,
    doLoading,
    authSuccess,
    gotError,
    currentUser,
    logout,
    unAuth,
    notApproved,
    blocked,
    loadProfile,
    authDrop,
    clearError,
    showError,
    getState,
    setStream,
    to404,

    messagesCount,
    affiliateLink,
    telegramHash,
    currentRoute,
}